import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/channels-page-skeleton.tpl.svg';

// Calibrated against the real Channels page loading layout. The static SVG's final row ends at
// 72.5em (1160px at the app skeleton template's 16px baseline); the remaining space preserves the
// page's bottom padding/breathing room so replacing the route skeleton does not collapse the page.
const containerStyles = { height: '1227px' } as const;

export const ChannelsPageSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} hideBorder containerStyles={containerStyles} />
);

export default ChannelsPageSkeleton;
